import * as api from '@lib/api';
import {
    addressAtom,
    bathsAtom,
    bedroomsAtom,
    emailAtom,
    firstNameAtom,
    lastNameAtom,
    phoneAtom,
} from '@src/state';
import { useRecoilState, useRecoilValue } from 'recoil';
import { EstimatorPath, SegmentEvents } from '../constants';

export const useAnalytics = (): Record<string, string | number | undefined> => {
    const address = useRecoilValue(addressAtom);
    const [firstName] = useRecoilState(firstNameAtom);
    const [lastName] = useRecoilState(lastNameAtom);
    const [email] = useRecoilState(emailAtom);
    const [phoneNumber] = useRecoilState(phoneAtom);
    const [bedrooms] = useRecoilState(bedroomsAtom);
    const [bathrooms] = useRecoilState(bathsAtom);

    return {
        address,
        firstName,
        lastName,
        email,
        phoneNumber,
        bedrooms,
        bathrooms,
    };
};

export const emitStepAnalytics = (
    path: EstimatorPath,
    phase?: 'start' | 'complete' | 'back',
    data?:
        | Record<string, unknown>
        | {
              estimate: 'available' | 'unavailable';
          },
): void => {
    api.emitAnalytics(`${SegmentEvents[path]}${phase ? `-${phase}` : ''}`, data);
};
